export const environment = {
  production: false,
  API_BASE_URL: 'https://api.tp-test.atzederserbe.de',
  AUTH_ACCESS_TOKEN_KEY: 'access_token',
  AUTH_USER_KEY: 'user',
  AUTH_REFRESH_TOKEN_KEY:"refresh_token",
  AUTH_EXPIRES_IN_KEY:'expires_in',
  version:"0.1.0+3fcbdd6afd4a37e364819682494654928ed23737-STAGING"
};
